var map = {
	"./Group 22302.png": 1315,
	"./avatar-christmas.webp": 1316,
	"./bottom-bg-christmas.webp": 1317,
	"./btn-active.png": 1318,
	"./content-deco-1.webp": 1319,
	"./content-deco-2.webp": 1320,
	"./content-deco-3.webp": 1321,
	"./content-deco-4.webp": 1322,
	"./deco-3.webp": 1323,
	"./deposit-icon.webp": 1324,
	"./home-icon-active.webp": 1325,
	"./home-icon.webp": 1326,
	"./live-icon-active.webp": 1327,
	"./live-icon.webp": 1328,
	"./master-bg.jpg": 1329,
	"./me-icon-active.webp": 1330,
	"./me-icon.webp": 1331,
	"./platform.png": 1332,
	"./platform.webp": 1333,
	"./promos-icon-active.webp": 1334,
	"./promos-icon.webp": 1335,
	"./promos.webp": 1336,
	"./service-christmas.webp": 1337,
	"./snowman.webp": 1338,
	"./sponsor-icon-active.webp": 1339,
	"./sponsor-icon.webp": 1340,
	"./title-deco-left.webp": 1341,
	"./title-deco-right.webp": 1342,
	"./tree.webp": 1343,
	"./vip-icon.webp": 1344,
	"./vip.webp": 1345,
	"./withdraw-icon.webp": 1346,
	"./wwr-img.webp": 1347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;